module.exports = __webpack_public_path__ + "img/photo-23.ff7dd8d7.jpg";